import { GlobalAxios } from "../axios/axios-config";

const NFE_TOTVS_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/ForubusNfeTotvs/RestartForubusNfeTotvsIntegration";

export const restartNfeTotvsRetries = ({ identifier }: { identifier: number }) => {
    return GlobalAxios.put(NFE_TOTVS_ROUTE, {
        identifier
    });
};
